import request from '@/utils/request'

export function getCompanyAdm(params) {
    return request({
        url: '/v2/sec/Setting/getCompanyAdm',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function changeChainPass (params) {
    return request({
      url: '/v2/sec/chainSetting/changeChainPass',
      method: 'post',
      data: params
    })
  }
  export function changeChainPub (params) {
    return request({
      url: '/v2/sec/chainSetting/changeChainPub',
      method: 'post',
      data: params
    })
  }
  export function downloadKeystoreFile (params) {
    return request({
      url: '/v2/sec/chainSetting/changeDownloadKeystoreFile',
      method: 'post',
      data: params
    })
  }
  export function getChainSetting(params) {
    return request({
        url: '/v2/sec/chainSetting/getChainSetting',
        method: 'post',
        data: params
    })
}
  